import { FilterType, MoveCategory, MoveFlag, PkmType } from './enums.js';
import { ColorPkmTypeBlocks, Debounce, movesJSON, WaitFetch } from './helper.js';
import { MoveFilters } from './interfaces.js';

var stickyOffset = -1;

var FilterSettings: MoveFilters = {
	PartialName: "",
	Categories: [],
	Types: [],
	Flags: [],
};

$(window).on("load", async function () {
	await WaitFetch();

	CreateMoveList();

	SetUpSorting();
	SetUpFilters();

	ColorKeywords();

	$(window).on('scroll', function () {
		if (window.scrollY > stickyOffset && stickyOffset > 0)
			$("#stickyHeader").addClass("sticky");
		else
			$("#stickyHeader").removeClass("sticky");
	});
});

function CreateSortArrow(down: boolean) {
	let svgArrowDown = `<div class="sortArrowDown"><svg fill="#eee" height="16px" width="16px" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="-33 -33 396.00 396.00" xml:space="preserve" stroke="#ffffff" stroke-width="0.00330002" transform="rotate(0)"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round" stroke="#CCCCCC" stroke-width="2.640016"></g><g id="SVGRepo_iconCarrier"> <path id="XMLID_23_" d="M329.155,100.036c-2.108-6.011-7.784-10.035-14.154-10.035h-300c-6.371,0-12.046,4.024-14.154,10.035 c-2.109,6.011-0.19,12.699,4.784,16.678l150.004,120c2.739,2.191,6.055,3.287,9.37,3.287c3.316,0,6.631-1.096,9.371-3.287 l149.996-120C329.346,112.734,331.264,106.047,329.155,100.036z"></path></g></svg></div>`;
	let svgArrowUp = `<div class="sortArrowUp"><svg fill="#eee" height="16px" width="16px" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="-33 -33 396.00 396.00" xml:space="preserve" stroke="#ffffff" stroke-width="0.00330002" transform="rotate(0)matrix(1, 0, 0, -1, 0, 0)"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round" stroke="#CCCCCC" stroke-width="2.640016"></g><g id="SVGRepo_iconCarrier"> <path id="XMLID_23_" d="M329.155,100.036c-2.108-6.011-7.784-10.035-14.154-10.035h-300c-6.371,0-12.046,4.024-14.154,10.035 c-2.109,6.011-0.19,12.699,4.784,16.678l150.004,120c2.739,2.191,6.055,3.287,9.37,3.287c3.316,0,6.631-1.096,9.371-3.287 l149.996-120C329.346,112.734,331.264,106.047,329.155,100.036z"></path> </g></svg></div>`;

	return down ? svgArrowDown : svgArrowUp;
}

function CreateMoveList() {
	let $header = $("<div>", {
		id: "stickyHeader",
		class: "row"
	})
		.append($("<div>", { class: "sortable firstSort" }).append($("<h5>", { class: "name", text: "Move" })))
		.append($("<div>", { class: "sortable" }).append($("<h5>", { class: "type", text: "Type" })))
		.append($("<div>").append($("<h5>", { text: "Category" })))
		.append($("<div>", { class: "sortable" }).append($("<h5>", { class: "pp", text: "PP" })))
		.append($("<div>", { class: "sortable" }).append($("<h5>", { class: "pow", text: "Pow" })))
		.append($("<div>", { class: "sortable" }).append($("<h5>", { class: "acc", text: "Acc" })))
		.append($("<div>").append($("<h5>", { text: "Effects" })))
		.append($("<div>").append($("<h5>", { text: "Flags" })));

	$("#moveList").append($header);

	stickyOffset = $("#stickyHeader").offset()!.top;

	let $rows: Array<JQuery<HTMLElement>> = [];
	Object.entries(movesJSON!).forEach(([move, moveInfo]) => {
		let $row = $("<div>", { class: "row move" })
			.append($("<div>").append($("<p>", { class: "name", text: move })))
			.append($("<div>").append($("<p>", { class: "type pkmTypeBlock last", text: moveInfo.Type })))
			.append($("<div>").append($("<img>", { class: "category", src: `/images/categoryIcons/${moveInfo.Category.toLowerCase()}.png`, data: { category: moveInfo.Category } })))
			.append($("<div>").append($("<p>", { class: "pp", text: moveInfo.PP })))
			.append($("<div>").append($("<p>", { class: "pow", text: (moveInfo.Power == 0 || moveInfo.Power == 1) ? "-" : moveInfo.Power })))
			.append($("<div>").append($("<p>", { class: "acc", text: moveInfo.Acc == 101 ? "-" : moveInfo.Acc })))
			.append($("<div>").append($("<p>", { class: "effects", text: moveInfo.Effects })))
			.append($("<div>").append($("<p>", { class: "flags", text: moveInfo.Flags.join(", ") })));

		$rows.push($row);
	});

	$("#moveList").append($rows);
	ColorPkmTypeBlocks();
}

function SetUpSorting() {
	SortMoveList("name", true);
	$(".firstSort").append(CreateSortArrow(false));
	
	$(".sortable").on("click", function () {
		$(".sortArrowDown").not($(this).find(".sortArrowDown")).remove();
		$(".sortArrowUp").not($(this).find(".sortArrowUp")).remove();

		let svgArrowDown = CreateSortArrow(true);
		let svgArrowUp = CreateSortArrow(false);
		let sortClass = $(this).find("h5")[0].className;

		// Sort Ascending
		if ($(this).find(".sortArrowDown").length) {
			$(".sortArrowDown").remove();
			$(this).append(svgArrowUp);
			SortMoveList(sortClass, true);
		}
		// Sort Descending
		else if ($(this).find(".sortArrowUp").length) {
			$(".sortArrowUp").remove();
			$(this).append(svgArrowDown);
			SortMoveList(sortClass, false);
		}
		// Selectively Sort Asc/Desc
		else {
			if (sortClass == "name" || sortClass == "type") {
				$(this).append(svgArrowUp);
				SortMoveList(sortClass, true);
			}
			else {
				$(this).append(svgArrowDown);
				SortMoveList(sortClass, false);
			}
		}
	});
}

function SortMoveList(sortClass: string, ascending: boolean) {
	let moveRows = $(".move");

	// Variation of Insertion Sort
	let i = 1;
	while (i < moveRows.length) {
		let j = i;
		let row = moveRows[i];

		let sortValue: string | number = $(moveRows[i]).find(`.${sortClass}`).text();
		let prevSortValue: string | number = $(moveRows[j - 1]).find(`.${sortClass}`).text();

		if (sortClass == "pp") {
			sortValue = parseInt(sortValue);
			prevSortValue = parseInt(prevSortValue);
		}
		else if (sortClass == "pow") {
			sortValue = parseInt(sortValue == "-" ? "0" : sortValue);
			prevSortValue = parseInt(prevSortValue == "-" ? "0" : prevSortValue);
		}
		else if (sortClass == "acc") {
			sortValue = parseInt(sortValue == "-" ? "101" : sortValue);
			prevSortValue = parseInt(prevSortValue == "-" ? "101" : prevSortValue);
		}

		while (j > 0 && (ascending ? prevSortValue > sortValue : prevSortValue < sortValue)) {
			moveRows[j] = moveRows[j - 1];
			j -= 1;
			prevSortValue = $(moveRows[j - 1]).find(`.${sortClass}`).text();

			if (sortClass == "pp") {
				prevSortValue = parseInt(prevSortValue);
			}
			else if (sortClass == "pow") {
				prevSortValue = parseInt(prevSortValue == "-" ? "0" : prevSortValue);
			}
			else if (sortClass == "acc") {
				prevSortValue = parseInt(prevSortValue == "-" ? "101" : prevSortValue);
			}
		}

		$(moveRows[j]).before(row);
		moveRows[j] = row;

		i += 1;
	}
}

function SetUpFilters() {
	// Reset Filters
	$("#filterMove").val("");
	$("#filterTypesList").val("All");
	$("#filterCategoriesList").val("All");
	$("#filterFlagsList").val("All");

	// Set Filter Defaults
	FilterSettings.Categories = Object.values(MoveCategory);
	FilterSettings.Types = Object.values(PkmType).slice(1); // Ignore None
	FilterSettings.Flags = Object.values(MoveFlag);

	// Flip boxes to true
	$("#filterTypesDropdown label input").each((_, ele) => {
		$(ele).prop("checked", true);
	});

	$("#filterCategoriesDropdown label input").each((_, ele) => {
		$(ele).prop("checked", true);
	});

	// Add Flags
	let flagLabels: Array<JQuery<HTMLElement>> = [];
	Object.values(MoveFlag).forEach(flag => {
		flagLabels.push($("<label>")
			.append($("<input>", { type: "checkbox", name: flag }).prop("checked", true))
			.append($("<p>", { text: flag })));
	});

	$("#filterFlagsDropdown").append(
		$("<div>", { class: "allNone"})
			.append($("<p>", { id: "flagAll", text: "All" }))
			.append($("<p>", { id: "flagNone", text: "None" }))
	);
	$("#filterFlagsDropdown").append(flagLabels);

	// Moves
	$("#filterMove").on("keyup paste focusin", function (e) {
		if (e.type == "keyup") {
			let skipReturn = false;
			
			if (e.key?.length == 1 && e.key?.match(/[a-z0-9.-]/i) || e.key == "Backspace")
				skipReturn = true;

			if (!skipReturn)
				return;
		}

		let searchVal = ($(this).val() as string).toLowerCase();

		Debounce($(this), 250, () => {
			FilterSettings.PartialName = searchVal;
			Filter();
		});
	});

	// Handle Open/Close
	$("#filterTypesList").on("click", () => OpenFilterDropdown(FilterType.Types));
	$("#filterCategoriesList").on("click", () => OpenFilterDropdown(FilterType.Categories));
	$("#filterFlagsList").on("click", () => OpenFilterDropdown(FilterType.Flags));

	// Types
	$("#typeAll").on("click", function() {
		$("#filterTypesDropdown label input").each((_, ele) => {
			$(ele).prop("checked", true);
		});

		$("#filterTypesList").val("All");

		FilterSettings.Types = Object.values(PkmType).slice(1);
		Filter();
	});

	$("#typeNone").on("click", function() {
		$("#filterTypesDropdown label input").each((_, ele) => {
			$(ele).prop("checked", false);
		});

		$("#filterTypesList").val("None");

		FilterSettings.Types = [];
		Filter();
	});

	$("#filterTypesDropdown label input").on("change", function() {
		let btns = $("#filterTypesDropdown label input").filter((_, ele) => $(ele).prop("checked"));

		if (btns.length == 18) {
			$("#filterTypesList").val("All");
		}
		else if (btns.length == 0) {
			$("#filterTypesList").val("None");
		}
		else {
			$("#filterTypesList").val(btns.map((_, ele) => $(ele).siblings("p").text()).get().join(", "));
		}

		FilterSettings.Types = btns.map((_, ele) => $(ele).siblings("p").text() as PkmType).get();
		Filter();
	});

	// Categories
	$("#filterCategoriesDropdown label input").on("change", function() {
		let btns = $("#filterCategoriesDropdown label input").filter((_, ele) => $(ele).prop("checked"));

		if (btns.length == 3) {
			$("#filterCategoriesList").val("All");
		}
		else if (btns.length == 0) {
			$("#filterCategoriesList").val("None");
		}
		else {
			$("#filterCategoriesList").val(btns.map((_, ele) => $(ele).siblings("p").text()).get().join(", "));
		}

		FilterSettings.Categories = btns.map((_, ele) => $(ele).siblings("p").text()).get();
		Filter();
	});

	// Flags
	$("#flagAll").on("click", function() {
		$("#filterFlagsDropdown label input").each((_, ele) => {
			$(ele).prop("checked", true);
		});

		$("#filterFlagsList").val("All");

		FilterSettings.Flags = Object.values(MoveFlag);
		Filter();
	});

	$("#flagNone").on("click", function() {
		$("#filterFlagsDropdown label input").each((_, ele) => {
			$(ele).prop("checked", false);
		});

		$("#filterFlagsList").val("None");

		FilterSettings.Flags = [];
		Filter();
	});

	$("#filterFlagsDropdown label input").on("change", function() {
		let btns = $("#filterFlagsDropdown label input").filter((_, ele) => $(ele).prop("checked"));

		if (btns.length == Object.keys(MoveFlag).length) {
			$("#filterFlagsList").val("All");
		}
		else if (btns.length == 0) {
			$("#filterFlagsList").val("None");
		}
		else {
			$("#filterFlagsList").val(btns.map((_, ele) => $(ele).siblings("p").text()).get().join(", "));
		}

		FilterSettings.Flags = btns.map((_, ele) => $(ele).siblings("p").text() as MoveFlag).get();
		Filter();
	});
}

function OpenFilterDropdown(filterType: FilterType) {
	let notOpen = $(`#filter${filterType}Dropdown`).css("display") == "none";

	$("#filterTypesDropdown").css("display", "none");
	$("#filterCategoriesDropdown").css("display", "none");
	$("#filterFlagsDropdown").css("display", "none");
 
	if (notOpen)
		$(`#filter${filterType}Dropdown`).css("display", "flex");
}

function Filter() {
	$(".move").each((_, ele) => {
		let move = $(ele).find(".name").text().toLowerCase();
		let type = $(ele).find(".type").text() as PkmType;
		let category = $(ele).find(".category").data("category");
		let flags = $(ele).find(".flags").text().split(", ");

		if (move.includes(FilterSettings.PartialName) &&
				FilterSettings.Types.includes(type) &&
				FilterSettings.Categories.includes(category) &&
				(FilterSettings.Flags.some(flag => flags.includes(flag)) || FilterSettings.Flags.length == Object.keys(MoveFlag).length)) {
			$(ele).css("display", "grid");
		}
		else
			$(ele).css("display", "none");
	});
}

function ColorKeywords() {
	let colorRanges: Record<string, Array<Range>> = {
		Number: [],
		Normal: [],
		Fire: [],
		Water: [],
		Electric: [],
		Grass: [],
		Ice: [],
		Fighting: [],
		Poison: [],
		Ground: [],
		Flying: [],
		Psychic: [],
		Bug: [],
		Rock: [],
		Ghost: [],
		Dragon: [],
		Steel: [],
		Dark: [],
		Fairy: [],
		HP: [],
		Atk: [],
		Def: [],
		SpA: [],
		SpD: [],
		Spe: [],
	};

	$(".move .effects").each((_, el) => {
		const textNodes = Array.from(el.childNodes).filter(node => node.nodeType == Node.TEXT_NODE);
		
		textNodes.forEach(node => {
			let text = node.textContent!;

			Object.keys(colorRanges).forEach(keyword => {
				let searchTerms = [keyword];

				if (keyword == "Number") {
					searchTerms.push("double");
				}

				if (keyword == "Dark") {
					searchTerms.push("sleep");
					searchTerms.push("asleep");
					searchTerms.push("Twilight Terrain");
				}
				else if (keyword == "Electric") {
					searchTerms.push("paralyz");
					searchTerms.push("paralysis");
					searchTerms.push("Electric Terrain");
				}
				else if (keyword == "Fairy") {
					searchTerms.push("Misty Terrain");
				}
				else if (keyword == "Fire") {
					searchTerms.push("burn");
					searchTerms.push("Harsh Sunlight");
				}
				else if (keyword == "Grass") {
					searchTerms.push("Grassy Terrain");
				}
				else if (keyword == "Ice") {
					searchTerms.push("Hail");
				}
				else if (keyword == "Normal") {
					searchTerms.push("Flinch");
				}
				else if (keyword == "Psychic") {
					searchTerms.push("Fatigue");
					searchTerms.push("Confus");
					searchTerms.push("Psychic Terrain");
				}
				else if (keyword == "Rock") {
					searchTerms.push("Sandstorm");
				}
				else if (keyword == "Water") {
					searchTerms.push("Rain");
				}

				searchTerms.forEach(term => {
					let regex, match;
					if (term == "Number")
						regex = new RegExp(/[+-]?\d+(?:\.\d+)?(?:\s*→\s*)?\d*(?:\.\d+)?(?:[stndrth]+|[%x]?)/, "g");
					else
						regex = new RegExp(`\\b${term}[edingo]*\\b`, "gi");

					while ((match = regex.exec(text)) != null) {
						let range = new Range();
						range.setStart(node, match.index);
						range.setEnd(node, match.index + match[0].length);

						colorRanges[keyword].push(range);

						if (match.index == regex.lastIndex)
							regex.lastIndex++;
					}
				});
			});
		});
	});

	Object.entries(colorRanges).forEach(([keyword, rangeList]) => {
		CSS.highlights.set(keyword, new Highlight(...rangeList));
	});
}